import React, {useEffect, useState} from "react";
import { useNavigate } from 'react-router-dom';
import { Alert, Box, Button, CircularProgress, Dialog, DialogContent, DialogTitle, FormControl, Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { AppHelper } from "../../AppHelper";
import EssaySubmitStatus from "../essay/essay-submit-status"; 

export default function PopResubmit({open, onClose, onResubmitPosted, recEssay, essayId}) {
  const [popOpen, setPopOpen] = useState(false);
  const [newEssayId, setNewEssayId] = useState("");
  const [startReprocess, setStartReprocess] = useState(false);

  useEffect(() => {
    setPopOpen(open);
  }, [open]);
  useEffect(() => {
  }, [recEssay]);

  const handleResubmit = (arg) => {
    const confirm = window.confirm("Are you sure you want to resubmit?");
    if (!confirm) {
      return;
    }
    resubmitEssay();
  }

  const resubmitEssay = async(arg) => {
    var _user = AppHelper.userCacheGet();
    var _url = 'api/essay/resubmitToReplace';
    var _payload = {token: _user.token, 
                    essayId: essayId,
                    replace: true
    };
    var _res = await AppHelper.apiPost(_url, _payload);

    if (!_res || !_res.status){
      console.error("Error: Failed to resubmit essay. ")
      return;
    }
    setNewEssayId(_res.data.essayId);
    setStartReprocess(true);
  }

  const handleEssayStatusCheckDone = ({ code, essayId }) => {
    if (code === 'NEW') {
      if (onResubmitPosted) {
        onResubmitPosted(essayId);
      }
      setPopOpen(false);
      if (onClose) {
        onClose();
      }
    }
  };

  const handleClose = () => {
    if(onClose) onClose();
  };

  return (
    <Dialog onClose={handleClose} fullWidth maxWidth="xs" open={popOpen}>
		  <DialogTitle>Resubmit</DialogTitle>
      { !startReprocess &&
      <div>
		  <DialogContent>
        <Box style={{textAlign:'center'}} mt={3}>
          <Button sx={{backgroundColor:'rgba(19,130,117,1)', ":hover":{backgroundColor:'rgb(157, 188, 152)'}}} 
                  onClick={()=>handleResubmit()} 
                  color="info" 
                  variant="contained">
                    Resubmit
          </Button>
        </Box>
		  </DialogContent>
		  <Button onClick={handleClose} style={{ position: 'absolute', top: 0, right: 0 }}>
        <CloseIcon />
      </Button>
      </div>
      }
      { startReprocess &&
    <Dialog onClose={handleClose} fullWidth maxWidth="s" open={popOpen}>
          <EssaySubmitStatus essayId={newEssayId} essayStatusCheckDone={handleEssayStatusCheckDone} />
          </Dialog>
      }
	  </Dialog>
  );
}